// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"c2f653a1","498":"7c6de7d2","553":"b4e96cc4","787":"84e92630"}[chunkId] + ".chunk.js";
};